export default function Configure($stateProvider) {
    $stateProvider.state('motifs', {
        parent: 'common',
        url: '/motifs',
        //abstract: true,
        views: {
            common: {
                template: '<ui-view></ui-view>'
            }
        },
        ncyBreadcrumb: {
            // le state étant parent et abstract, on décide de ne pas l'afficher dans le fil d'ariane
            //skip: true
            label: '{{ "LAYOUT.NAVIGATION.DONNEES_PARAMETRES" | translate }}'
        }
    });

    $stateProvider.state('motifs.list', {
        url: '/list',
        template: '<motifs></motifs>',
        rights: { domain: 'motifannulation', right: 'read' },
        ncyBreadcrumb: {
            label: '{{ "MOTIFS.BREADCRUMBS.MOTIFS_LIST" | translate}}'
        },
        // on affiche la liste des motifs dans la navigation
        navigation: {
            menu: 'donnees_parametres_parametres',
            translate: 'MOTIFS.BREADCRUMBS.MOTIFS_LIST',
            order: 35
        },
        // la liste des motifs fait partie des points d'entrée recherchables dans la navigation
        search: 'MOTIFS.BREADCRUMBS.MOTIFS_LIST'
    });

    $stateProvider.state('motifs.new', {
        url: '/new',
        template: '<motifs-form></motifs-form>',
        rights: { domain: 'motifannulation', right: 'create' },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher motifs > ajouter
            parent: 'motifs.list',
            label: '{{ "MOTIFS.BREADCRUMBS.MOTIF_NEW" | translate}}'
        },
        // l'ajout d'une motif fait partie des points d'entrée recherchables dans l'application
        search: 'MOTIFS.BREADCRUMBS.MOTIF_NEW'
    });

    $stateProvider.state('motifs.edit', {
        url: '/{id}/edit',
        template: '<motifs-form></motifs-form>',
        rights: { domain: 'motifannulation', right: 'update' },
        ncyBreadcrumb: {
            // on décide que la liste est le parent des autres states
            // afin d'afficher motifs > modifier
            parent: 'motifs.list',
            label: '{{ "MOTIFS.BREADCRUMBS.MOTIF_EDIT" | translate }}'
        }
    });
}

Configure.$inject = ['$stateProvider'];
